import React from 'react'

import {
  AnimatedCheckMark,
  Flex,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { Button } from 'src/design_system/components/Button/Button'

type StepConfirmationProps = {
  onSkip: () => void
  onContinue: () => void
  isMobile: boolean
}

export const StepConfirmation: React.FC<StepConfirmationProps> = ({
  onSkip,
  onContinue,
  isMobile,
}) => {
  return (
    <>
      <Flex
        style={{
          padding: '1rem 2rem 2rem 2rem',
          paddingBottom: isMobile ? '80px' : '2rem',
        }}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          <Spacer space="x6" />
          <AnimatedCheckMark size="large" />
          <Spacer space="x3" />
          <Text type="largeBody">Your Package setup is Complete.</Text>
          <Spacer space="x2" />
        </Flex>
      </Flex>
      <Flex
        justifyContent="flex-end"
        alignItems="center"
        inset={{ horizontal: 'x4', bottom: 'x2' }}
        style={{
          position: isMobile ? 'fixed' : undefined,
          bottom: isMobile ? 0 : undefined,
          right: isMobile ? 20 : undefined,
          backgroundColor: isMobile ? '#F8F5F6' : undefined,
        }}
      >
        <div onClick={onSkip} style={{ cursor: 'pointer' }}>
          <Text
            type="body"
            weight="semiBold"
            style={{ textDecoration: 'underline' }}
            content="Continue Shopping"
          />
        </div>
        <Spacer space="x2" orientation="horizontal" />
        <Button
          title="Proceed to Checkout"
          backgroundColor="#404040"
          textColor="#FFF"
          textSize="14px"
          padding="0.75rem 2rem"
          onClick={onContinue}
        />
      </Flex>
    </>
  )
}
